module.exports = "/lucky-balls/img/combos-sr/7-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/7-.png
// module id = 992
// module chunks = 0